<template>
  <!--右上角用户顶部-->
  <div style="display: flex;align-items: center">
    <el-tooltip effect="light" placement="top" v-if="!isInDingTalk">
      <div slot="content">产品公告</div>
      <div style="width: 30px">
        <i class="el-icon-message-solid" @click="productNoticeFn" style="color: #ffffff; font-size: 16px"></i>
        <sup style="vertical-align: super"><span style="width: 5px; height: 5px; border-radius: 50%; background-color: #ffffff; display: inline-block"></span></sup>
      </div>
    </el-tooltip>
    <div class="userHeader-wrap">
    <span class="info" v-if="loginUser">
<!--      <img-->
<!--        v-if="this.src= this.loginUser.userType === 1"-->
<!--        class="photo"-->
<!--        :src="loginUser.imgPath ? fileOperShow(loginUser.imgPath) : ''"-->
<!--        onerror="this.src='/images/web/login_enterprise_icon.png'"-->
<!--      />-->
<!--      <img-->
<!--        v-else-->
<!--        class="photo"-->
<!--        :src="loginUser.imgPath ? fileOperShow(loginUser.imgPath) : ''"-->
<!--        onerror="this.src='/images/web/login_user_icon.png'"-->
<!--      />-->
      <span class="name" :title="getUserName">{{ getUserName }}</span>
      <i class="icon-arrow" v-if="!isInDingTalk"></i>
    </span>
      <ul>
<!--        <li @click="gotoAccountCenter()">-->
<!--          <span class="icon-au"></span>账户中心-->
<!--        </li>-->
        <li @click.stop="logout()" v-if="!isInDingTalk">
          <span class="icon-exit"></span>退出登录
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  logout,
  fileOperShow
} from "../../assets/js/http-serve/http-methods";
import {
  setCurrentUser
} from "@/assets/js/http-serve/corp/common";
import { isInDingTalk } from "../../assets/js/utils/ding-env";
import GlobalConfig from '../../assets/js/config/global'
export default {
  name: "userHeader",
  props: {},
  data() {
    return {
      isInDingTalk,
      logout: logout,
      fileOperShow: fileOperShow
    };
  },
  computed: {
    loginUser() {
      return this.$store.getters.allAuthUser
        ? this.$store.getters.allAuthUser.accountInfoVO
        : {};
    },
    getUserName() {
      return (
        this.loginUser.name ||
        this.loginUser.username ||
        this.loginUser.emailMask ||
        this.loginUser.mobileMash
      );
    }
  },
  methods: {
    //产品公告
    productNoticeFn() {
      window.open(GlobalConfig.domain.junziqianMain + '/product_notice-0.html')
    },
    // goto 消费统计
    consumption() {
      this.$router.push({ path: "/tpl/costStatistics" });
    },
    // goto 签署安全
    safetyer() {
      this.$router.push({ path: "/tpl/signMerge" });
    },
    // goto 数字证书授权
    certificate() {
      this.$router.push({ path: "/tpl/digital" });
    },
    // goto 账户中心
    gotoAccountCenter() {
      if (
        this.$store.getters.allAuthUser.manCorpUser &&
        this.$store.getters.allAuthUser.manCorpUser.corpUserId ===
          this.$store.getters.currentAuthUser.corpUserId
      ) {
        if (this.$route.path !== "/console/account") {
          this.$router.push({ path: "/console/account" });
        }
      } else {
        // 切换登录用户
        setCurrentUser(this.loginUser).finally(() => {
          // this.$router.push({ path: "/signSettings/accountInfo" });
          if (this.loginUser.userType === 1) {
            this.$router.push({ path: "/console/account" });
          } else if (this.$route.path !== "/signSettings/costStatistics") {
            this.$router.push({ path: "/signSettings/costStatistics" });
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .tree-icon-1 {
    background-position: 0 0 !important;
    background-size: 500% 500% !important;
    display: inline-block;
    vertical-align: middle;
    background-image: url("/images/icon/tree-icon.png");
    background-repeat: no-repeat;
  }
.userHeader-wrap {
  width: 200px;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  font-size: 14px;
  &:hover {
    overflow: initial;
    background: rgba(225, 225, 225, 0.3);
    .icon-arrow {
      transform: rotate(180deg);
    }
    ul {
      width: auto;
      height: auto;
      z-index: 100;
      display: block;
      top: 60px;
      opacity: 1;
    }
  }
  .name {
    display: inline-block;
    max-width: 160px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #ffffff;
    font-size: 14px;
  }
  .icon-arrow {
    transition: all ease 0.2s;
    width: 10px;
    height: 10px;
    margin-left: 10px;
  }
  .info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    padding-left: 10px;
    .photo {
      border-radius: 50%;
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
  ul {
    width: 0;
    height: 0;
    z-index: -100;
    overflow: hidden;
    /*transition: all ease 0.2s;*/
    transition-property: opacity, top;
    transition-duration: 0.2s, 0.2s;
    transition-timing-function: ease;
    position: absolute;
    /*display: none;*/
    left: 0;
    top: 0;
    right: 0;
    opacity: 0;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
    li {
      cursor: pointer;
      background: #ffffff;
      height: 50px;
      line-height: 50px;
      color: #290202;
      box-sizing: border-box;
      padding-left: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &:hover {
        background: #f9f6f6;
      }
      span {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/header/userHeader.vue